import { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { useLanguage } from "@/app/utils/LanguageContext";

interface tabProps {
  onTabChange: (type: any) => void;
  type: string;
  curTab: string;
}

interface SwitchProps {
  onChange?: (isOn: boolean) => void; // Optional callback for state changes
  label1:string;
  label2:string;
  type: string;
  curTab:string;
}

const Switch: React.FC<SwitchProps> = ({ onChange, label1,label2,type,curTab}) => {
  const [isOn, setIsOn] = useState(false);
  
  useEffect(()=>{
    switch(curTab){
      case "HV":
        setIsOn(true);
        break;
      case "ST":
        setIsOn(false);
        break;
      default: 
        setIsOn(false)
        break;
    }
  },[curTab])

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - rect.left;

    if (clickX < rect.width / 2 && isOn) {
      setIsOn(false);
      if (onChange) onChange(false);
    } else if (clickX >= rect.width / 2 && !isOn) {
      setIsOn(true);
      if (onChange) onChange(true);
    }
  };

  return (
    <div className={`${styles.switch}  ${type === "mobile" && styles.mobile_style} ${isOn ? `${styles.switchOn} `: `${styles.switchOff}` }`} onClick={handleClick}>
      <div className={`${styles.slider}`  }></div>
      <div className={`${styles.labelOn}`}>{label1}</div>
      <div className={`${styles.labelOff}`}>{label2}</div>
    </div>
  );
}


const TrackTab: React.FC<tabProps> = (props) => {
  const [tab, setTab] = useState<any>("ST");
  const { state: lang } = useLanguage();
  const { t } = lang;

  useEffect(() => {
    if (typeof window !== "undefined") {
      setTab(
        sessionStorage.getItem("currentTab")
          ? sessionStorage.getItem("currentTab")
          : props.curTab
          ? props.curTab
          : "ST"
      );
    }
  }, [props.curTab]);

  const handleTabChange = (type: any) => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem("currentTab", type);
    }
    setTab(type);
    props.onTabChange(type);
  };

  const handleToggle = (isOn: boolean) => {
    //default ST, ON = HV, OFF = ST
    if (typeof window !== "undefined") {
      sessionStorage.setItem("currentTab", isOn?"HV":"ST");
    }
    setTab(isOn?"HV":"ST");
    props.onTabChange(isOn?"HV":"ST");
  
    console.log('Switch is', isOn ? 'ON' : 'OFF');
  };

  return (
    <div
      className={`${styles.Container} ${
        props.type === "pc" && styles.pcPadding
      }`}
    >
      {/* <div
        className={`${styles.tabWrapper} ${
          props.type === "mobile" && styles.mobile_style
        }`}
      >
        <div
          onClick={() => handleTabChange("ST")}
          className={`${styles.left} ${
            props.type === "mobile" && styles.mobile_inner_height
          } ${tab === "ST" && styles.selected}`}
        >
          <p>{t("w_ST")}</p>
        </div>
        <div
          onClick={() => handleTabChange("HV")}
          className={`${styles.right} ${
            props.type === "mobile" && styles.mobile_inner_height
          } ${tab === "HV" && styles.selected}`}
        >
          <p>{t("w_HV")}</p>
        </div>

      </div> */}
      <Switch onChange={handleToggle} label1={t("w_ST")} label2={t("w_HV")} type={props.type} curTab = {props.curTab}/>
    </div>
  );
};
export default TrackTab;
